import AbstractColumn from "./AbstractColumn.js";

/**
 * Empty column, used as a separator.
 *
 * @param {boolean} [spec.narrow = true] - Whether the column should have the
 *   width of a regular column.
 * @param {boolean} [spec.borderOnly = false] - When enabled, the separator
 *   column will be only render as a border, and no extra space will be added.
 *   This can be done by adding a border to the previous column, but the
 *   last one.
 */
class SeparatorColumn extends AbstractColumn {
	constructor({ narrow = true, borderOnly = false } = {}) {
		super(...arguments);

		this._narrow = narrow;
		this._borderOnly = borderOnly;
	}

	isNarrow() {
		return this._narrow;
	}

	isBorderOnly() {
		return this._borderOnly;
	}

	canBeReferenced() {
		return false;
	}

	canBeCalculated() {
		return false;
	}

	isSeparator() {
		return true;
	}

	cssClass() {
		return [
			"separator-column",
			{ narrow: this._narrow, "border-only": this._borderOnly },
		];
	}

	accept(visitor) {
		return visitor.visitSeparatorColumn(this);
	}

	shouldShowContent() {
		return true;
	}

	getSerializableLeaves() {
		return [];
	}

	_getDefaultTitle() {
		return "";
	}

	_serializedProperties() {
		const properties = super._serializedProperties(...arguments);

		properties.isNarrow = this._narrow;
		properties.isBorderOnly = this._borderOnly;

		return properties;
	}

	static getType() {
		return "SeparatorColumn";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.narrow = data.isNarrow;
		data.borderOnly = data.isBorderOnly;
	}
}

export default SeparatorColumn;
